import React, { useEffect, useState } from 'react'
import {FaHeartbeat} from 'react-icons/fa'
import { InView, useInView } from 'react-intersection-observer';

const Footer = () => {
  const { ref, inView } = useInView();
  //const [isClick, setClick] = useState(false);
  // useEffect(() => {
  //   if(InView){
  //     setClick(true)
  //   }
  // })
  return (
    <div ref={ref}
      className="flex justify-center space-x-5 items-center mt-20 py-5 shadow-2xl shadow-blue-400 bg-black bg-opacity-40"
    >
      <p className='font-semibold text-gray-200'>Made by </p>
      <FaHeartbeat className='text-red-600'/>
      <p className="text-blue-700 font-bold">Ashok Zarmariya</p>
    </div>
  )
}

export default Footer
